export const packOptions = [
  { value: "starter", label: "Эхлэл (starter)" },
  { value: "growth", label: "Өсөлт (growth)" },
  { value: "pro", label: "Pro" },
  { value: "business", label: "Байгууллага (business)" },
];

export const userFeeTypeOptions = [
  { value: "FIXED", label: "Тогтмол дүн (₮)" },
  { value: "PERCENT", label: "Нэхэмжлэлийн дүнгийн хувь (%)" },
];

export const MERCHANT_CREATE_DEFAULTS = {
  pack: "starter",
  productTypeId: 1,
  feePercent: 10,
  spayFeePercent: 1,
  userFee: 800,
  userFeeType: "FIXED",
  sendWelcomeEmail: true,
};

export function payerFeePreview(amount, userFee, userFeeType) {
  const base = Number(amount) || 0;
  const fee = Number(userFee) || 0;
  if (!fee) {
    return { fee: 0, total: base };
  }
  if (userFeeType === "PERCENT") {
    const computed = (base * fee) / 100;
    return { fee: computed, total: base + computed };
  }
  return { fee, total: base + fee };
}

export function merchantToFormValues(merchant) {
  if (!merchant) {
    return { ...MERCHANT_CREATE_DEFAULTS };
  }
  return {
    name: merchant.name,
    email: merchant.email,
    register: merchant.register,
    phone: merchant.phone,
    phone2: merchant.phone2,
    address: merchant.address,
    pack: merchant.pack || "starter",
    productTypeId: merchant.productTypeId ?? 1,
    accountNumber: merchant.accountNumber,
    bankCode: merchant.bankCode,
    feePercent: merchant.feePercent,
    spayFeePercent: merchant.spayFeePercent,
    userFee: merchant.userFee ?? 0,
    userFeeType: merchant.userFeeType || "FIXED",
  };
}
